import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {IUserSearch,IUserParams,IUserInsert,IUserUpdata,IUserDisable,IUserDetail} from "./userTypes"
class UserService {
    async page(params:IUserSearch){
        const apiUrl = "/md/user/page"
        return await httpRequest.post<IPage<IUserDetail>>(apiUrl,params)
    }
    async insert(params:IUserInsert){
        const apiUrl = "/md/user/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IUserUpdata){
        const apiUrl = "/md/user/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IUserDisable){
        const apiUrl = "/md/user/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const userService = new UserService()
export {
    userService
}